import { ContentLink, useContentSingletons, usePageContent, useXcoreUtils } from "@robe/client/xcore-ui";
import { Box, BoxProps, Stack, Typography } from "@xcorejs/ui";
import LeftMenu from "design-system/robe/LeftMenuContainer/LeftMenu";
import { Fragment } from "react";
import { News, NewsDetailPage } from "xcore/types";
import Popover from "../../../design-system/robe/Popover";
import ProductCard from "design-system/robe/Cards/Product";

const ProductsIncluded = (props: BoxProps) => {
  const { stringify } = useXcoreUtils();
  const news = usePageContent<News>();
  const [detailPage] = useContentSingletons<[NewsDetailPage]>();

  return (
    <Box width="100%" {...props}>
      <Typography variant="h3" as="h2" mb={{ _: ".5rem", md: "1.5rem" }} textAlign={{ _: "center" }}>
        {stringify(detailPage.values.productInvolved)}
      </Typography>
      <LeftMenu>
        <Stack gap="1.5rem" direction="row" justifyContent="center" flexWrap="wrap" {...({ flexFlow: "wrap" } as any)}>
          {news.values.products?.map((p, i) => {
            if (!p.values || !p.id || !p.type || !p.slug) {
              return <Fragment key={i} />;
            }

            return (
              <Popover
                key={i}
                popover={<ProductCard product={{ values: p.values }} width="30rem" />}
                _popover={{
                  marginLeft: "50%",
                  borderTop: "0.6rem solid transparent",
                }}
              >
                <ContentLink content={{ id: p.id, type: p.type, slug: p.slug }} queries={{ backto: news.id }} mt=".5rem">
                  <span>{stringify(p.title)}</span>
                </ContentLink>
              </Popover>
            );
          })}
        </Stack>
      </LeftMenu>
    </Box>
  );
};

export default ProductsIncluded;
